export const getSafeAreaTop = (): number => {
  const style = getComputedStyle(document.documentElement)
  const safeAreaInsetTop = style.getPropertyValue('--safe-area-inset-top')

  if (safeAreaInsetTop) {
    return parseInt(safeAreaInsetTop.replace('px', '')) || 0
  }

  const testEl = document.createElement('div')
  testEl.style.paddingTop = 'env(safe-area-inset-top)'
  document.body.appendChild(testEl)
  const computedPadding = getComputedStyle(testEl).paddingTop
  document.body.removeChild(testEl)

  return parseInt(computedPadding) || 0
}
